import { AvaliacaoCardiologicaData } from "../interfaces/avaliacaoCardiologica.interface";

export type AvaliacaoCardiologicaFormData = AvaliacaoCardiologicaData;

export const getInitialData = (initialData?: Partial<AvaliacaoCardiologicaData>): AvaliacaoCardiologicaFormData => {
  return {
    // Histórico Clínico
    hipertensaoArterial: initialData?.hipertensaoArterial ?? false,
    diabetesMellitus: initialData?.diabetesMellitus ?? false,
    doencaCardiacaPrevia: initialData?.doencaCardiacaPrevia ?? false,
    historiaInsuficienciaRenal: initialData?.historiaInsuficienciaRenal ?? false,
    procedimentosCirurgicosPrevios: initialData?.procedimentosCirurgicosPrevios ?? "",
    // Índice de Lee
    historiaInfartoMiocardio: initialData?.historiaInfartoMiocardio ?? false,
    insuficienciaCardiacaSintomatica: initialData?.insuficienciaCardiacaSintomatica ?? false,
    doencaCerebrovascular: initialData?.doencaCerebrovascular ?? false,
    diabetesMellitusInsulina: initialData?.diabetesMellitusInsulina ?? false,
    insuficienciaRenalCronica: initialData?.insuficienciaRenalCronica ?? false,
    cirurgiaGrandePorte: initialData?.cirurgiaGrandePorte ?? false,
    // Exame Físico
    pressaoArterial: initialData?.pressaoArterial ?? "",
    frequenciaCardiaca: initialData?.frequenciaCardiaca ?? "",
    auscultaCardiacaPulmonar: initialData?.auscultaCardiacaPulmonar ?? "",
    edemaSinaisIC: initialData?.edemaSinaisIC ?? false,
    eletrocardiograma: initialData?.eletrocardiograma ?? "",
    ecocardiograma: initialData?.ecocardiograma ?? "",
    outrosExames: initialData?.outrosExames ?? "",
    // Diagnóstico e Conduta
    riscoCirurgicoCardiaco: initialData?.riscoCirurgicoCardiaco ?? "",
    recomendacoesPreOperatorias: initialData?.recomendacoesPreOperatorias ?? "",
    examesSolicitados: initialData?.examesSolicitados ?? [],
    observacoesExames: initialData?.observacoesExames ?? "",
  };
};
